export const ASSET_TYPE = 'rig'

export function setUrl(rig: any) {
    window.location = getUrl(rig)
}

export function getUrl(rig) {
    return rig ? `/#/${ASSET_TYPE}/${rig.id}` : '/'
}

export const getRigEmptyNormalizer = (rig: { name: string }): AssetNormalizerEntity => {
    return {
        ...getEmptyNormalizer(rig, ASSET_TYPE),
        ignore_missing_units: true,
        enabled: true
    }
}

export function debounce(func, timeout = 300){
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => { func.apply(this, args); }, timeout);
    };
}